/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import Head from 'next/head';
import dynamic from 'next/dynamic';
import {
    AppBar,
    Tabs,
    Tab,
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    Paper,
    Card,
    CardHeader,
    CardContent,
    Chip,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import styles from 'styles/pages/segments-segment.module.scss';
import getSegments from 'lib/getSegments';
import getBrandsModels from 'lib/getBrandsModels';
import getPosts from 'lib/getPosts';
import { urlWriter } from 'tools/functions';
import { apiQl } from 'lib/functions';
import { PRICE_RANGES, CONVERSION_FUEL } from 'parameters';
import Link from 'components/link';
import Breadcrumb from 'components/breadcrumb';

const WidgetNav = dynamic(() => import('../../components/widgetNav'), {
    ssr: false,
});

const WidgetLaunches = dynamic(() => import('../../components/widgetLaunches'), {
    ssr: false,
});

const WidgetPromo = dynamic(() => import('../../components/widgetPromotion'), {
    ssr: false,
});

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`spec-tabpanel-${index}`}
            aria-labelledby={`spec-tab-${index}`}
            {...other}
        >
            {value === index && children}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `spec-tab-${index}`,
        'aria-controls': `spec-tabpanel-${index}`,
    };
}

const Segment = (props) => {
    const { segment, priceRanges, brands } = props;
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };
    const getUnique = (versions, item) => {
        const allItems = versions.map((vs) => {
            if (item[1] === 'fuel') {
                return CONVERSION_FUEL[vs[item[0]][item[1]]];
            }
            return item.length === 1 ? vs[item[0]] : vs[item[0]][item[1]];
        });
        return [...new Set(allItems)].toString();
    };
    return (
        <div>
            <Head>
                <title>
                    {`Voitures ${segment.segment} neuves au Maroc | par budget et prix
                    ${segment.segment} neuf au Maroc`}
                </title>
                <meta
                    name="description"
                    content={`Toutes les voitures ${segment.segment} neuves au Maroc."`}
                />
                <meta property="og:type" content="siteweb" />
                <meta
                    property="og:title"
                    content={`Voiture ${segment.segment} au Maroc `}
                />
                <meta
                    property="og:image"
                    content={`${process.env.NEXT_PUBLIC_API_HOST}/images/models/${segment.image}`}
                />
                <meta
                    property="og:url"
                    content={`${
                        process.env.NEXT_PUBLIC_CLIENT_HOST
                    }/segments-automobile/${urlWriter(segment.segment)}`}
                />
                <link
                    rel="canonical"
                    href={`${
                        process.env.NEXT_PUBLIC_CLIENT_HOST
                    }/segments-automobile/${urlWriter(segment.segment)}`}
                />
            </Head>

            <main className={styles.root}>
                <Breadcrumb
                    links={[
                        {
                            href: '/segments-automobile',
                            text: 'segments voiture',
                        },
                        {
                            href: null,
                            text: segment.segment,
                        },
                    ]}
                />
                <div className="main-title">
                    <h1>{`Voitures ${
                        segment.segment === 'voiture-verte'
                            ? 'hybrides & electriques'
                            : segment.segment
                    } neuves Maroc`}</h1>
                    <Chip label={`${segment.modelsLength} modèles`} />
                </div>
                <Card className={styles.cardRoot}>
                    <CardHeader title="Modèles par gamme de prix" subheader="mille DH" />
                    <CardContent>
                        <div className={styles.cardContent}>
                            <AppBar position="static">
                                <Tabs
                                    value={tabValue}
                                    onChange={handleTabChange}
                                    variant="scrollable"
                                    scrollButtons="on"
                                    aria-label="gammes de prix"
                                >
                                    {priceRanges.map((priceRange, index) => (
                                        <Tab
                                            key={priceRange.id}
                                            label={priceRange.id}
                                            {...a11yProps(index)}
                                        />
                                    ))}
                                </Tabs>
                            </AppBar>
                            {priceRanges.map((priceRange, index) => (
                                <TabPanel
                                    key={`panel${priceRange.id}`}
                                    value={tabValue}
                                    index={index}
                                >
                                    <TableContainer component={Paper}>
                                        <Table
                                            className={styles.table}
                                            aria-label={priceRange.id}
                                        >
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell component="th" scope="row">
                                                        Marque
                                                    </TableCell>
                                                    {priceRange.models.map((model) => (
                                                        <TableCell key={model.model}>
                                                            {model.brand.brand}
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell component="th" scope="row">
                                                        Modèle
                                                    </TableCell>
                                                    {priceRange.models.map((model) => (
                                                        <TableCell key={model.model}>
                                                            <Link
                                                                href={`/modeles-voiture/${model.brand.brand.replace(
                                                                    / /g,
                                                                    '-',
                                                                )}/${model.model.replace(
                                                                    / /g,
                                                                    '-',
                                                                )}`}
                                                            >
                                                                {model.model}
                                                            </Link>
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell component="th" scope="row">
                                                        Qté versions
                                                    </TableCell>
                                                    {priceRange.models.map((model) => (
                                                        <TableCell key={model.id}>
                                                            {model.versions.length}
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell component="th" scope="row">
                                                        Prix
                                                    </TableCell>
                                                    {priceRange.models.map((model) => (
                                                        <TableCell key={model.id}>
                                                            {model.versions.length === 1
                                                                ? Math.floor(
                                                                      Math.round(
                                                                          model
                                                                              .versions[0]
                                                                              .prices
                                                                              .edges[0]
                                                                              .node
                                                                              .price /
                                                                              1000,
                                                                      ),
                                                                  )
                                                                : `${Math.floor(
                                                                      Math.round(
                                                                          model
                                                                              .versions[0]
                                                                              .prices
                                                                              .edges[0]
                                                                              .node
                                                                              .price /
                                                                              1000,
                                                                      ),
                                                                  )}-${Math.floor(
                                                                      Math.round(
                                                                          model.versions[
                                                                              model
                                                                                  .versions
                                                                                  .length -
                                                                                  1
                                                                          ].prices
                                                                              .edges[0]
                                                                              .node
                                                                              .price /
                                                                              1000,
                                                                      ),
                                                                  )}`}
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell component="th" scope="row">
                                                        Combustible
                                                    </TableCell>
                                                    {priceRange.models.map((model) => (
                                                        <TableCell key={model.id}>
                                                            {getUnique(model.versions, [
                                                                'motor',
                                                                'fuel',
                                                            ])}
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </TabPanel>
                            ))}
                        </div>
                    </CardContent>
                </Card>
                <WidgetNav brands={brands} />
                <WidgetLaunches data={brands} />
                <WidgetPromo data={brands} />
            </main>
        </div>
    );
};

Segment.propTypes = {
    priceRanges: PropTypes.array.isRequired,
    segment: PropTypes.object.isRequired,
    brands: PropTypes.array.isRequired,
};

export default Segment;

const queryQl = `query getSegment(
  		$id: ID!
  	    $isActiveModel: Boolean!
        ){
    segment(id: $id) {
        id
        segment
        models(isActive: $isActiveModel) {
            id
            model
            images(isFeatured: true) {
                filename
            }
            modelYear
            brand {
                id
                brand
            }
            versions(
                isActive: true
                exists: {prices:true}
            ) {
                id
                version
                prices(
                    first: 1
                    after: null
                    _order: {createdAt: "DESC"}
                ) {
                    edges {
                        node {
                            id
                            createdAt
                            price
                            promo
                        }
                    }
                }
                motor {
                    power
                    fuel
                }
            }
        }
    }
}`;

const queryQl4x4 = `query getModelsSegment4x4{
    models(
        isActive: true
        versions_traction_list:["4x4"]
    ) {
        id
        model
        modelYear
        images(isFeatured: true) {
                filename
            }
        brand {
            id
            brand
        }
        versions(
            isActive: true
            exists: {prices:true}
            traction_list: ["4x4"]
        ) {
            id
            version
            prices(
                first: 1
                after: null
                _order: {createdAt: "DESC"}
            ) {
                edges {
                    node {
                        id
                        createdAt
                        price
                        promo
                    }
                }
            }
            motor {
                power
                fuel
            }
        }
    }
}`;

const queryQlHE = `query getModelsSegmentHybridElectric{
    models(
        isActive: true
        versions_motor_fuel_list: ["hybrid", "electric"]
    ) {
        id
        model
        modelYear
        images(isFeatured: true) {
                filename
            }
        brand {
            id
            brand
        }
        versions(
            isActive: true
            exists: {prices:true}
            motor_fuel_list: ["hybrid", "electric"]
        ) {
            id
            version
            prices(
                first: 1
                after: null
                _order: {createdAt: "DESC"}
            ) {
                edges {
                    node {
                        id
                        createdAt
                        price
                        promo
                    }
                }
            }
            motor {
                power
                fuel
            }
        }
    }
}`;

export async function getStaticPaths() {
    let segments = await getSegments();
    segments = segments.data.segments;
    const paths = [];
    segments.forEach((segment) => {
        paths.push({
            params: {
                segment: urlWriter(segment.segment),
            },
        });
    });
    paths.push({
        params: {
            segment: '4x4',
        },
    });
    paths.push({
        params: {
            segment: 'voiture-verte',
        },
    });
    return {
        paths,
        fallback: false,
    };
}

export async function getStaticProps({ params }) {
    const { segment: segmentParam } = params;
    let posts = await getPosts();
    posts = posts.data.posts;
    let brands = await getBrandsModels();
    brands = brands.data.brands;
    let segment = {};
    if (segmentParam === '4x4') {
        const data = await apiQl(queryQl4x4, null, false);
        segment = {
            id: '4x4',
            segment: '4x4',
            models: data.data.models,
        };
    } else if (segmentParam === 'voiture-verte') {
        const data = await apiQl(queryQlHE, null, false);
        segment = {
            id: 'voiture-verte',
            segment: 'voiture-verte',
            models: data.data.models,
        };
    } else {
        let segments = await getSegments();
        segments = segments.data.segments;
        const segmentFilter = segments.filter((seg) => {
            return urlWriter(seg.segment) === segmentParam;
        });
        const variables = {
            id: segmentFilter[0].id,
            isActiveModel: true,
        };
        const data = await apiQl(queryQl, variables, false);
        segment = data.data.segment;
    }
    const priceRanges = [];
    PRICE_RANGES.forEach((range) => {
        const newModels = [];
        segment.models.forEach((mod) => {
            const versions = mod.versions.filter((vs) => {
                return (
                    vs.prices.edges[0].node.price > range[0] &&
                    vs.prices.edges[0].node.price < range[1]
                );
            });
            if (versions.length > 0) {
                newModels.push({ ...mod, versions });
            }
        });
        if (newModels.length > 0) {
            priceRanges.push({
                id: `${(parseInt(range[0], 10) - 1) / 1000}-${
                    parseInt(range[1], 10) / 1000
                }`,
                models: [...newModels],
            });
        }
    });
    return {
        props: {
            brands,
            priceRanges,
            posts,
            segment: {
                id: segment.id,
                segment: segment.segment,
                modelsLength: segment.models.length,
                image: segment.models[0].images[0].filename,
            },
        },
    };
}
